<template>
  <section>
    <b-alert show variant="info">
      The .xlsx download also includes a second sheet, with the orders and order items on backorder for these products.
    </b-alert>
    <TableListing :items="items" :fields="fieldsAll" :showPaginationRow="true" :pagination.sync="pagination" :options.sync="tableOptions">
      <template v-slot:cell(quantityBackordered)="data">
        <span class="text-danger">{{ data.item.quantityBackordered }}</span>
      </template>
    </TableListing>
  </section>
</template>

<script>
import { TableListing } from '@/views/components/custom';
import { myCommonDataMixin } from '@/helpers/utils/vueMixins.js';
export default {
  mixins: [myCommonDataMixin],
  name: 'ReportItemsOnBackorder-view',
  components: {
    TableListing: TableListing
  },
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  mounted() {
    this.tableOptions.totalRows = this.items.length;
  },
  data() {
    return {
      pagination: {
        sortBy: '',
        sortDesc: false,
        perPage: 10,
        page: 1
      },
      tableOptions: {
        totalRows: 10,
        loadedAll: true
      },
      fieldsAll: [
        { key: 'storefrontName', label: 'Storefront', sortable: true },
        { key: 'sku', label: 'Sku', sortable: true },
        { key: 'name', label: 'Product', sortable: true },
        //{ key: 'quantity', label: 'Quantity', sortable: true },
        //{ key: 'quantityDemand', label: 'Demand', sortable: true },
        { key: 'quantityBackordered', label: 'QTY On Backorder', sortable: true },
        { key: 'backorderedOrderCount', label: 'Backorders', sortable: true }
      ]
    }
  }
}
</script>
